import { useTranslation } from 'react-i18next';
import { ApiError } from 'shared/api';
import { searchSkills } from 'shared/api/entities';
import { Skill } from 'shared/types';

import ServerSearchAutocomplete from '../ServerSearchAutocomplete';
import { ServerAutocompleteProps } from '../ServerSearchAutocomplete/ServerSearchAutocomplete';

const skillFetcher = async (query: string, signal?: AbortSignal): Promise<Skill[] | ApiError> => {
    const response = await searchSkills(query, undefined, undefined, signal);

    if (response instanceof ApiError) {
        return response;
    }
    
    return response.items;
};

type SkillAutocompleteProps<Multiple extends boolean = false> = Omit<ServerAutocompleteProps<Skill, Multiple>,
    'getOptionLabel' |
    'search'
>

export default function SkillAutocomplete<Multiple extends boolean = false>({
    multiple,
    ...rest
}: SkillAutocompleteProps<Multiple>) {
    const { t } = useTranslation('common');

    return (
        <ServerSearchAutocomplete<Skill, Multiple> 
            size="small"
            multiple={ multiple }
            label={ multiple ? t('commonEntities.skills') : t('commonEntities.skill') }
            search={{
                fetcher: skillFetcher,
                minLength: 2,
                preloadOnMount: true
            }}
            { ...rest }
        />
    );
}
